import React from 'react';
import HeroSection from '../HeroSection';
import { motion } from 'framer-motion';
import FloatingMenu from '../FloatingMenu';
import '../styles/Home.css';

const Home = () => (
  <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1 }} style={{position:'relative', minHeight:'100vh', background:'#27173A', overflow:'hidden'}}>
    <HeroSection />
    <FloatingMenu />
    {/* Add more animated intro/overview content here if needed */}
    <footer className="footer-powered">
      &copy; {new Date().getFullYear()} Powered by Nariman and Neda
    </footer>
  </motion.div>
);

export default Home;
